import { Injectable } from "@angular/core";
import * as xlsx from 'xlsx'

@Injectable({
    providedIn: 'root'
})

/**
 * This service is relevant to the admin side
 * This service allows for the interpreting of spreadsheets
 * Currently, this service uses two libraries to interact
 * with spreadsheets, and they serve marginally different purposes,
 * but it is expected to remove xlsx and use only exceljs
 */
export class SpreadsheetService {
    /**
     * Converts a spreadsheet to an array of objects
     * @param file the spreadsheet as a File
     * @returns the sheet as an array of objects,
     * where the keys in each object are the headers
     * of each column
     */
    convertSpreadsheet(file: File, raw = false, options: xlsx.Sheet2JSONOpts = undefined): Promise<Array<any>> {
        return new Promise((resolve) => {
            //initiates the file reader
            const reader = new FileReader()
            //initiates the reader loading listener
            reader.onload = (e) => {
                //attempts to read the result of the file reader as a spreadsheet
                const workbook = xlsx.read(e.target.result, {type: 'array', raw: raw});
                //extracts the first sheet of the spreadsheet
                const relevantSheet = Object.values(workbook.Sheets)[0]
                //converts the first sheet to an array of objects
                const sheetAsJSON = xlsx.utils.sheet_to_json(relevantSheet, options)
                resolve(sheetAsJSON)
            }
            //reads the file as an ArrayBuffer
            reader.readAsArrayBuffer(file)
        })
    }

    /**
     * Converts an excel format date number to a JS Date object
     * @param excelDate the excel format date number
     * @returns a JS Date representation of the date
     */
    excelDateToJS(excelDate: number): Date {
        const secondsInDay = 24 * 60 * 60;
        const missingLeapYearDay = secondsInDay * 1000;
        const delta = excelDate - (25567 + 2);
        const parsed = delta * missingLeapYearDay;
        const timeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
        return new Date(parsed - 8 * 60 * 60 * 1000);
    }

    /**
     * Converts a JS format date number to an Excel serial number
     * @param jsDate the JS date as either a ms time or a date object
     * @returns 
     */
    jsDateToExcel(jsDate: number | Date) {
        const date = new Date(jsDate);
        // Adjust to GMT + 8 and set to start of the day
        return Math.floor(25569.0 + ((date.getTime() + 8 * 60 * 60 * 1000) / (1000 * 60 * 60 * 24)));
    }
}